export default __webpack_public_path__ + "static/media/GoogleIcon.9db27c10.png";